import { useSelector } from 'react-redux';
import { useWhiteLabel } from '../context/WhiteLabelContext';

/**
 * On a white-label domain, only the WL owner may create a workspace (the backend
 * enforces this in createWorkspace; this hook hides the UI so non-owners don't
 * hit a 403). On the main / non-WL domain, anyone may create.
 *
 * @returns {boolean} whether the current user can create a workspace here.
 */
export const useCanCreateWorkspace = () => {
  const { isWhiteLabel } = useWhiteLabel();
  const isWhiteLabelOwner = useSelector((state) => state.user.isWhiteLabelOwner);
  return !isWhiteLabel() || !!isWhiteLabelOwner;
};
